import {map} from 'lodash';

import './index.scss';
import cfthornImage from 'images/staff/cfthorn.jpg';
import cjkleinImage from 'images/staff/cjklein.jpg';
import evangeliaImage from 'images/staff/evangelia.jpg';
import ingridImage from 'images/staff/ingrid.jpg';
import jamesImage from 'images/staff/james.jpg';
import kellyImage from 'images/staff/kelly.jpg';
import ksangkuhlImage from 'images/staff/ksangkuhl.jpg';
import lgongImage from 'images/staff/lgong.jpg';
import maryImage from 'images/staff/mary.jpg';
import matthewImage from 'images/staff/matthew.jpg';
import mcarrilloImage from 'images/staff/mcarrillo.jpg';
import mwoonImage from 'images/staff/mwoon.jpg';
import roseImage from 'images/staff/rose.jpg';
import rwhaleyImage from 'images/staff/rwhaley.jpg';
import tkleinImage from 'images/staff/tklein.jpg';
import tmurrayImage from 'images/staff/tmurray.jpg';

import Link from 'components/links/Link';
import ReadableWidthTemplate from 'components/templates/ReadableWidth';
import TeamPerson from 'pages/Team/person';


const staff = [
  {
    name: 'Teri E. Klein, PhD',
    title: 'Principal Investigator',
    image: tkleinImage,
    bio: `Dr. Klein is the Principal Investigator for the PharmGKB and Professor
         of Biomedical Data Science and Medicine. Dr. Klein is also the Co-Principal Investigator
         for CPIC (Clinical Pharmacogenetics Implementation Consortium). She was recruited from the
         University of California, San Francisco faculty and was the Director of the PharmGKB
         since it began in April 2000 until September 2019. Teri received her PhD in medical
         information sciences from the University of California, San Francisco and a BA in
         biology/chemistry from the University of California, Santa Cruz. Prior to becoming the
         director of the PharmGKB in 2000, Dr. Klein was an Associate Adjunct Professor at UCSF.`,
    biosketchUrl: 'https://www.ncbi.nlm.nih.gov/myncbi/teri.klein.1/cv/608454/',
  },
  {
    name: 'Michelle Whirl-Carrillo, PhD',
    title: 'Principal Investigator & Director',
    image: mcarrilloImage,
    bio: `Dr. Whirl-Carrillo is the Director and Principal Investigator of ClinPGx in the Department of Biomedical Data 
        Science at Stanford University. She heads the ClinPGx team, and leads or has a key role in many collaborative 
        projects that leverage structured PGx knowledge for the advancement of personalized medicine. Her research 
        interests include the development of manual and automated curation processes for annotating scientific 
        literature; creation and application of terminologies, definitions and rule-based systems to PGx knowledge to 
        aid computational data analysis and clinical implementation; and automated methods to annotate genotype and 
        sequence data for translation to PGx-based therapeutic recommendations. Michelle received her PhD in Biophysics 
        from Stanford University and her SB in Biology from MIT.`,
    conflict: '',
    biosketchUrl: 'https://www.ncbi.nlm.nih.gov/myncbi/michelle.whirl-carrillo.1/cv/581204/',
  },
  {
    name: 'Li Gong, PhD',
    title: '',
    image: lgongImage,
    bio: `Dr. Gong is a Senior Scientific Curator at ClinPGx in the Department of Biomedical Data Science at Stanford University. She joined
          the team in 2007. Prior to this, Li worked as a senior scientist at Iconix Biosciences
          Inc. working on microarray data analysis, biomarker discovery and curation for the
          development of DrugMatrixR toxicogenomics database. She holds a PhD in Molecular Biology
          and Microbiology from Tufts University School of Medicine, and a BS in Microbiology from
          Beijing University, P.R. China.`,
    conflict: '',
    biosketchUrl: 'https://www.ncbi.nlm.nih.gov/myncbi/lgong/cv/582982/',
  },
  {
    name: 'Katrin Sangkuhl, PhD',
    title: '',
    image: ksangkuhlImage,
    bio: `Dr. Sangkuhl is a Senior Scientific Curator at ClinPGx in the Department of Biomedical Data Science at 
          Stanford University. She joined the team in 2008. Prior to this, Katrin was a Postdoctoral Fellow at the 
          Department of Reproductive Biology & Program for Regenerative Medicine, Stanford University. She received her
          PhD in Biochemistry from the University Leipzig, Germany working in the field of GPCRs and signal
          transduction.`,
    conflict: '',
    biosketchUrl: 'https://www.ncbi.nlm.nih.gov/myncbi/1VyNv9OKhCZ5l/cv/581369/',
  },
  {
    name: 'Caroline F. Thorn, PhD',
    title: '',
    image: cfthornImage,
    bio: `Dr. Thorn is a Scientific Curator at ClinPGx in the Department of Biomedical Data Science at Stanford
          University. She joined the team in 2003. She took two hiatuses when her children were born and spent a brief
          time as a Senior Program Administrator for the American Association for Cancer Research and returned to the
          PharmGKB in 2015. She has a PhD in Genetics from Trinity College University of Dublin, BSc
          Hons in Biochemistry from University of Bath UK and did postdoctoral training at
          University of Pennsylvania in Pharmacology and pharmacogenomics. She has been a lecturer
          on the University of Pennsylvania Topics in Pharmacogenomics course since 2010 and one of
          her favorite PGx memories is teaching on the Stanford South Africa course.`,
    conflict: '',
    biosketchUrl: 'https://www.ncbi.nlm.nih.gov/myncbi/caroline.thorn.1/cv/581414/',
  },
  {
    name: 'Ingrid Keseler, PhD',
    title: '',
    image: ingridImage,
    bio: `Dr. Keseler is a Scientific Curator at ClinPGx in the Department of Biomedical Data Science at Stanford
        University. She joined the team in 2022. She previously was a senior biocurator for the EcoCyc model-organism
        database and the PI of the BsubCyc MOD at SRI International.  Before she discovered biocuration, she was a
        Senior Scientist at Clontech, where she led the design of probes for human, mouse and rat microarrays. She holds
        an MS in Microbiology from the University of Georgia, a PhD in Biochemistry from Stanford University, and did
        postdoctoral work at the Stanford Human Genome Center.`,
    conflict: '',
  },
  {
    name: 'Evangelia Eirini Tsermpini, PhD',
    title: '',
    image: evangeliaImage,
    bio: `Dr. Tsermpini is a Scientific Curator at ClinPGx in the Department of Biomedical Data Science at Stanford
      University. She joined the team in 2025. Before this role, she honed her expertise as a postdoctoral fellow in the
      Department of Psychiatry at Dalhousie University in Halifax, Canada. With a PhD from the University of Patras in 
      Greece, her thesis focused on pharmacogenomics, striving to personalize treatment for those battling 
      schizophrenia and emotional psychosis.`,
    conflict: '',
    biosketchUrl: 'https://www.ncbi.nlm.nih.gov/myncbi/evangelia.tsermpini@stanford.edu/cv/1568669/',
  },
  {
    name: 'Mark Woon, BSE',
    title: '',
    image: mwoonImage,
    bio: `Mark Woon is a developer in the Department of Biomedical Data Science at Stanford University and co-technical 
        lead of ClinPGx. He joined the team in 2001. Prior to this, Mark worked for Sun Microsystems and Netscape 
        Communications. He received his BSE in computer science from Princeton University.`,
    conflict: '',
    biosketchUrl: 'https://www.ncbi.nlm.nih.gov/myncbi/markwoon/cv/581201/',
  },
  {
    name: 'Ryan Whaley, BS',
    title: '',
    image: rwhaleyImage,
    bio: `Ryan Whaley is a software developer in the Department of Biomedical Data Science at Stanford University and 
          co-technical lead of ClinPGx. He is a Java developer with a background in database
          administration and project management and has been with the PharmGKB since 2007. Ryan
          received his BS in Computer Science and Mathematics at the University of Iowa and then
          went on to become the database administrator and senior software developer for the
          Department of Internal Medicine at the University of Iowa Hospitals & Clinics.`,
    conflict: '',
    biosketchUrl: 'https://www.ncbi.nlm.nih.gov/myncbi/ryan.whaley.1/cv/581236/',
  },
  {
    name: 'Tiffany Murray, BA',
    title: '',
    image: tmurrayImage,
    bio: `Tiffany Murray coordinates the activities for the ClinPGx PIs and is responsible for  communications 
          involving consortia, data licensing, and content use. She has a BA from the University of  California at San 
          Diego.`,
    conflict: '',
    biosketchUrl: 'https://www.ncbi.nlm.nih.gov/myncbi/tiffany.murray.1/cv/118013/',
  },
  {
    name: 'Clarissa Klein, BA',
    title: '',
    image: cjkleinImage,
    bio: `Clarissa Klein coordinates the ClinPGx pediatric summaries, as well as other writing and editing projects. 
          She has worked on and off with the ClinPGx (formerly PharmGKB) since 2015 and received her BA in English from 
          Harvard College. Clarissa previously worked in veterinary medicine and wildlife rehabilitation.`,
    conflict: '',
  },
  {
    name: 'Matt W. Wright, PhD',
    title: '',
    image: matthewImage,
    bio: `Dr. Wright is Director of Stanford ClinGen and is a Senior Research Engineer in the Department of Biomedical 
      Data Science. Matt works on the development of PGx Community Curation interfaces for PharmGKB, among other things. 
      Matt received his PhD in Neuroscience from University College London, and a BSc in Anatomy/Physiology from 
      the University of Bristol. His postdoctoral work has included many biocuration projects, including the HGNC, 
      RefSeq (NCBI, Bethesda, MD), and since 2015 the Stanford ClinGen project. His current research focuses on 
      building the infrastructure to support the efforts of the ClinGen (Clinical Genome Resource) consortium to 
      collect and archive information about clinically relevant genes and genomic variants for use in precision medicine.`,
    conflict: '',
  },
];

const sjStaff = [
  {
    name: 'Kelly E. Caudle, PharmD, PhD, BCPS, FCCP',
    title: 'Principal Investigator',
    image: kellyImage,
    bio: `Dr. Caudle received her Pharm.D. and Ph.D. from The University of Tennessee Health Science Center and 
    completed an ASHP-accredited PGY2 residency at Le Bonheur Children’s Hospital in Memphis, TN. She is also a 
    board‐certified Pharmacotherapy Specialist.  She started working with CPIC in 2012 and is also currently an 
    affiliate Assistant Professor at The University of Tennessee Health Science Center. Dr. Caudle oversees all 
    CPIC-related projects and the CPIC guideline development process including the coordination of the guideline 
    writing committees, the guideline evidence reviews, and the writing of the guideline manuscript and supplement. 
    Furthermore, Dr. Caudle is involved in the clinical implementation of pharmacogenetics at St. Jude Children’s 
    Research Hospital. She has published over 50 manuscripts in the area of pharmacogenomics.`,
  },
  {
    name: 'Mary V. Relling, PharmD',
    title: '',
    image: maryImage,
    bio: `Dr. Relling earned her undergraduate B.S. degree from the University of Arizona College of Pharmacy and her 
    doctoral degree from the University of Utah College of Pharmacy.   She completed post-doctoral fellowships with Dr.
     William Evans at St. Jude and with Dr. Urs Meyer at University of Basel. She joined St. Jude as a faculty member 
     in 1988, and was chair of the Department of Pharmaceutical Sciences from 2003-2020.  She is also a professor at 
     the University of Tennessee in the Colleges of Medicine and Pharmacy. Her primary interests are in treatment and 
     pharmacogenetics of childhood leukemia and clinical implementation of pharmacogenetic testing. Dr. Relling is part 
     of NIH’s Pharmacogenomics Research Network and co-founder of CPIC, the Clinical Pharmacogenetics Implementation 
     Consortium. She has published over 400 original scientific manuscripts. She was elected to the Institute of 
     Medicine in 2009. Dr. Relling receives investigator-initiated research funding from Servier. Her spouse is on the 
     board of BioSkryb.`,
  },
  {
    name: 'James M. Hoffman, PharmD',
    title: '',
    image: jamesImage,
    bio: 'CPIC Informatics Co-Director St. Jude Children’s Research Hospital, Memphis, TN',
  },
  {
    name: 'Roseann S. Gammal, PharmD, BCPS',
    title: '',
    image: roseImage,
    bio: `Dr. Gammal is an Associate Professor of Pharmacy Practice at Massachusetts College of Pharmacy and Health 
    Sciences (MCPHS University) in Boston, MA. She received her Bachelor of Science degrees in Chemistry and 
    Biochemistry from Worcester Polytechnic Institute and her Doctor of Pharmacy degree from MCPHS University School of 
    Pharmacy in Worcester, MA.  She completed a PGY1 Pharmacy Practice residency at the University of North Carolina 
    Medical Center in Chapel Hill, NC and a PGY2 specialty residency in Clinical Pharmacogenetics at St. Jude 
    Children’s Research Hospital in Memphis, TN. Dr. Gammal is a Board Certified Pharmacotherapy Specialist (BCPS). She 
    started working with CPIC in 2015 and coordinates the development of CPIC guidelines. Dr. Gammal is also the 
    co-founder and lead clinical pharmacist for the Pharmacogenomics Clinic at Brigham and Women’s Hospital in Boston.`,
  },
];


export default function TeamPage() {
  return (
    <ReadableWidthTemplate title="ClinPGx Team" className="team">
      <div>
        <p>Contact us at <Link href="mailto:feedback@clinpgx.org">feedback@clinpgx.org</Link></p>
        <h2>Principal Investigators</h2>
        <ul>
          <li>Teri E. Klein, PhD, Stanford University</li>
          <li>Michelle Whirl-Carrillo, PhD, Stanford University</li>
          <li>Kelly E. Caudle, PharmD, PhD, St. Jude Children&apos;s Research Hospital</li>
          <li>Marylyn D. Ritchie, PhD, University of Pennsylvania</li>
        </ul>
      </div>

      <div className="team__members">
        <h2 className="section-heading">Stanford Team</h2>
        <div className="flex-staff">
          {map(staff, (s) => <TeamPerson key={s.name} staff={s} />)}
          {/* max of 5 staff per row, so only need 4 spacers */}
          <div className="staff-spacer" />
          <div className="staff-spacer" />
          <div className="staff-spacer" />
          <div className="staff-spacer" />
        </div>
      </div>

      <div className="team__members">
        <h2 className="section-heading">St. Jude Children's Research Hospital Team</h2>
        <div className="flex-staff">
          {map(sjStaff, (s) => <TeamPerson key={s.name} staff={s} />)}
          {/* max of 5 staff per row, so only need 4 spacers */}
          <div className="staff-spacer" />
          <div className="staff-spacer" />
          <div className="staff-spacer" />
          <div className="staff-spacer" />
        </div>
      </div>

    </ReadableWidthTemplate>
  );
}
